export const USER_INFO = 'userInfo'
export const CONFERENCE_USER_INFO = 'conferenceUserInfo'
export const AUTH_LOGIN = 'login'
export const CONFERENCE_AUTH_LOGIN = 'conferenceLogin'
export const AUTH_LOGOUT = 'logout'
export const CONFERENCE_AUTH_LOGOUT = 'conferenceLogout'
export const USER_UPDATE_PASSWORD = 'userUpdatePassword'
export const USER_SETTINGS = 'userSettings'
export const TOKEN = 'token'

export const RESET_PASSWORD_REQUEST = 'resetPasswordRequest'
export const RESET_PASSWORD = 'resetPassword'

export const SIGN_UP = 'SIGN_UP'
export const CONFERENCE_SIGN_UP = 'CONFERENCE_SIGN_UP'
export const CONFERENCE_AUTHOR_PROFILE = 'CONFERENCE_AUTHOR_PROFILE'
export const CONFERENCE_AUTHOR_PROFILE_SUBMIT = 'CONFERENCE_AUTHOR_PROFILE_SUBMIT'
export const SMS_SEND = 'smsSend'
export const EMAIL_SEND = 'emailSend'
export const VERIFY_EMAIL = 'verifyEmail'
